export var keepMount = function keepMount(store) {
  store.listen(function () {});
};